/**
 * Created by swchen on 2017/2/14.
 */


export default class NumasException extends Error {
    constructor(code, message, level) {
        super(message);
        this.code = code;
        this.level = level;
        // 修复原型链
        Object.setPrototypeOf(this, NumasException.prototype);
    }
}

// 兼容所有环境的静态属性定义
NumasException.UNKNOWN = "UNKNOWN";
